import { useQuery } from '@tanstack/react-query';

import { CategoryParent } from '../../../../constants';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { CATEGORIES_BASE_PATH } from '../../constants/categoriesBasePath';
import { getCategories } from '../../requests/getCategories';

export const useCategories = (
  parent: CategoryParent,
  options?: { enabled?: boolean; includeChildren?: boolean },
) => {
  const { constructPost } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getCategories>>
  >({
    queryKey: [CATEGORIES_BASE_PATH, parent, options?.includeChildren],
    queryFn: async () =>
      getCategories(constructPost, {
        parent,
        ...(options?.includeChildren && { 'include[]': 'childCategories' }),
      }),
    staleTime: Infinity,
    enabled: options?.enabled !== false,
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'categories'),
    ...rest,
  };
};
